import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {AutoCompleteCompleteEvent} from "primeng/autocomplete";
import {ContractType, Partner} from "../../../cross/user-insurance/types/ds-user-added-insurance.types";
import {InsurableObjectService} from "../../../cross/user-insurance/api/user-added-insurance-api.service";
import {FormFieldsDtoForInsurance} from "../../types/ob.interfaces";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {Observable} from "rxjs";

@Component({
  selector: 'form-field-auto-complete',
  templateUrl: 'auto-complete-form-field.component.html',
})
export class AutoCompleteFormFieldComponent implements OnInit, OnChanges {

  @Input() formGroup!: FormGroup;
  @Input() formField!: FormFieldsDtoForInsurance;
  filteredResults: Partner[] | ContractType[] = [];

  selectedItem: Partner | undefined;

  constructor(protected insurableObjectService: InsurableObjectService, protected messageService: AppMessageService) {
  }

  ngOnInit() {
    this.handleExistingComponent();
  }

  handleExistingComponent() {
    this.selectedItem = undefined;

    const idKey = this.formField.id
    const id = this.formGroup.get(idKey)?.value;

    if (id) {
      const nameKey = idKey.replace('DtoId', 'DtoName');
      const name = this.formGroup.get(nameKey)?.value;
      this.selectedItem = {id: id, name: name};
    }

  }

  getResult(event: AutoCompleteCompleteEvent) {
    const observable = this.getObservable(event.query);
    if (!observable) {
      return;
    }
    observable.subscribe((res: Partner[] | ContractType[]) => {
      this.filteredResults = res;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  getObservable(searchString: string): Observable<Partner[]> | Observable<ContractType[]> | null {
    if (this.formField.dataType == 'cm.ContractType') {
      return this.insurableObjectService.contractTypes(searchString);
    } else if (this.formField.dataType == 'eu.EuPartner') {
      return this.insurableObjectService.partners(searchString);
    }
    return null;
  }

  handleClear() {
    if (this.formField) {
      this.formGroup.patchValue({
        [this.formField.id]: null
      });
    }
  }

  handleManualFieldValueAssignment(form: FormGroup, field: string, value: number) {
    form?.patchValue({[field]: value});
  }

  ngOnChanges(changes: SimpleChanges) {
    this.handleExistingComponent();
  }
}
